import { createSlice } from '@reduxjs/toolkit'

const securityVerificationModalState = createSlice({
  name: 'securityVerificationModalState',
  initialState: {
    open: false,
    data: {
      callback: () => {}
    }
  },
  reducers: {
    setSecurityVerificationModalOpen: (state, action) => {
      state.open = action.payload
    },
    setSecurityVerificationModalData: (state, action) => {
      state.data = action.payload
    }
  }
})

export const { setSecurityVerificationModalOpen, setSecurityVerificationModalData } = securityVerificationModalState.actions

export default securityVerificationModalState.reducer